import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PagesLoginAlpha } from './login-alpha.page';
import { PagesPage404 } from './page-404.page';
import { PagesPage500 } from './page-500.page';
export const routes: Routes = [
  { path: 'pages/login', component: PagesLoginAlpha },
  { path: 'pages/page-404', component: PagesPage404 },
  { path: 'pages/page-500', component: PagesPage500 }
];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    PagesPage404,
    PagesPage500
  ]
})
export class PagesModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/pages/pages.module.ts